import { Store } from 'vuex';
import { minBy as _minBy, isEmpty as _isEmpty } from '@lodash';
import { IState } from '@app/store';
import { UPDATE_TIMESTAMP } from './mutationTypes';
import DateUtils from '@core/utils/date/DateUtils';
import LottoEvent from '@core/models/lotto/LottoEvent';

const APPROX_MAX_PAGE_STAY_TIME = 3600; // 1 h

const findClosestEvent = (lottoEvents: IState['data']['lottoOffer']['lottoEvents']) =>
    _minBy(Object.values(lottoEvents), (event: LottoEvent) => {
        if (event.endBet && event.endBet < new Date()) {
            // basically filter event which have already expired
            return DateUtils.addHours(APPROX_MAX_PAGE_STAY_TIME * 2, new Date());
        }
        return event.endBet;
    });

export default function (store: Store<IState>, { lottoEventsSetter }: { lottoEventsSetter: string }) {
    let timeoutId: number | null = null;
    let closestEventTime: Date | null = null;

    // set only timeout if there are events which are ending in the next hour
    const shouldSetTimeout = (date: Date) => {
        const oneHourLater = new Date(DateUtils.addSeconds(new Date(), APPROX_MAX_PAGE_STAY_TIME));
        return !closestEventTime
            || DateUtils.differenceInMinutes(date, oneHourLater) < 0;
    };

    // update the timestamp/cache buster only if there is not a timeout already in progress
    const addTimeout = (when: Date, callback: Function) => {
        if (timeoutId) {
            clearInterval(timeoutId);
        }
        const duration = DateUtils.differenceInMilliseconds(when, new Date());
        if (duration > 0) {
            timeoutId = setTimeout(
                () => {
                    store.commit(`ui/lotto/${UPDATE_TIMESTAMP}`);
                    callback();
                },
                duration) as any;
        }
    };

    // bust the cache when the closest event finishes
    const setupCacheBust = () => {
        const closestEvent = findClosestEvent(store.state.data.lottoOffer.lottoEvents);
        if (closestEvent!.endBet && shouldSetTimeout(closestEvent!.endBet)) {
            closestEventTime = closestEvent!.endBet;
            addTimeout(closestEventTime, setupCacheBust);
        }
    };

    store.subscribe((mutation, state) => {
        if (mutation.type === lottoEventsSetter && !_isEmpty(state.data.lottoOffer.lottoEvents)) {
            setupCacheBust();
        }
    });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/lotto/subscriptions.ts